import { render } from "./App.vue?vue&type=template&id=05d5b4a5&scoped=true&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=05d5b4a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05d5b4a5"

export default script